import * as Models from "../.";
export interface ICostCalculationResponse {
    market: Models.CostCalculation.Market.IMarket;
    annualProduction: number;
    systemSize: number;
    escalator: Models.CostCalculation.Escalator.IEscalator;
    rate: number;
    epcCost: number;
    completionTime: Date;
    isReconcile: boolean;
    customerReferenceNumber: string;
    product: string;
    systemDetails?: Models.SystemDetails.SystemDetails.ISystemDetails;
}

export class CostCalculationResponse implements ICostCalculationResponse {
    market: Models.CostCalculation.Market.Market;
    annualProduction: number;
    systemSize: number;
    escalator: Models.CostCalculation.Escalator.Escalator;
    rate: number;
    epcCost: number;
    completionTime: Date;
    isReconcile: boolean;
    customerReferenceNumber: string;
    product: string;
    systemDetails?: Models.SystemDetails.SystemDetails.ISystemDetails;
}
